export const lightTheme = {
  name: 'light',
  colors: {
    white: 'hsl(230, 17%, 14%)',
    bg: 'hsl(0, 0%, 100%)',
    gray: 'hsl(228, 12%, 44%)',
    cardColor: '#f0f3fa',
    activeCardColor: '#e1e3f0',
    twitter: 'hsl(203, 89%, 53%)',
    facebook: 'hsl(208, 92%, 53%)',
    instagram:
      'linear-gradient(97deg, rgba(253,196,104,1) 0%, rgba(223,73,150,1) 100%)',
    instaOrange: 'hsl(37, 97%, 70%)',
    instaRed: 'hsl(329, 70%, 58%)',
    youtube: 'hsl(348, 97%, 39%)',
    red: 'hsl(356, 69%, 56%)',
    green: 'hsl(163, 72%, 41%)',
  },
};

export const darkTheme = {
  name: 'dark',
  colors: {
    white: 'hsl(0, 0%, 100%)',
    bg: 'hsl(230, 17%, 14%)',
    gray: 'hsl(228, 34%, 66%)',
    cardColor: 'hsl(232, 19%, 15%)',
    activeCardColor: 'hsl(228, 28%, 20%)',
    twitter: 'hsl(203, 89%, 53%)',
    facebook: 'hsl(208, 92%, 53%)',
    instagram:
      'linear-gradient(97deg, rgba(253,196,104,1) 0%, rgba(223,73,150,1) 100%)',
    instaOrange: 'hsl(37, 97%, 70%)',
    instaRed: 'hsl(329, 70%, 58%)',
    youtube: 'hsl(348, 97%, 39%)',
    red: 'hsl(356, 69%, 56%)',
    green: 'hsl(163, 72%, 41%)',
  },
};
